import { LocalStorage } from './LocalStorage';

enum CoreLocalStorageProps {
  IsQuickGuideShown = 'isQuickGuideShown',
}

interface CoreLocalStorageAPI {
  increaseQuickGuideShownCount(tableId: string): void;
  getQuickGuideShownCount(tableId: string): number;
}

export const CoreLocalStorage: CoreLocalStorageAPI = {
  increaseQuickGuideShownCount: (tableId: string): void => {
    const storedValue = LocalStorage.get(CoreLocalStorageProps.IsQuickGuideShown + '-' + tableId);
    LocalStorage.set(
      CoreLocalStorageProps.IsQuickGuideShown + '-' + tableId,
      (storedValue ? Number(storedValue) + 1 : 1).toString()
    );
  },
  getQuickGuideShownCount: (tableId: string): number => {
    const storedValue = LocalStorage.get(CoreLocalStorageProps.IsQuickGuideShown + '-' + tableId);
    return storedValue ? Number(storedValue) : 0;
  },
};
